import { type FC, type ReactNode } from 'react';

import { Skeleton, TextSkeleton } from '@wwe-portal/ui/components/skeleton';

const Layout: FC<{
  avatarSlot: ReactNode;
  displayNameSlot: ReactNode;
  factionSlot: ReactNode;
  subscrpition?: ReactNode;
}> = ({ avatarSlot, displayNameSlot, factionSlot, subscrpition }) => {
  return (
    <div className="flex flex-col items-center gap-2.5">
      <div className="relative flex h-[110px] w-[130px] items-center justify-center">
        {avatarSlot}
      </div>
      <div className="flex flex-col items-center">
        <div className="text-text300 text-base font-medium">
          {displayNameSlot}
        </div>
        <div className="text-secondary text-xs">{factionSlot}</div>
      </div>
      {subscrpition}
    </div>
  );
};

export interface UserInfoProps {
  avatar: ReactNode;
  displayName: string;
  faction?: string;
  subscrpition?: ReactNode;
}
export const UserInfo: FC<UserInfoProps> = ({
  avatar,
  displayName,
  faction,
  subscrpition,
}) => {
  return (
    <Layout
      avatarSlot={avatar}
      displayNameSlot={displayName}
      factionSlot={faction ?? 'No Faction'}
      subscrpition={subscrpition}
    />
  );
};

export const UserInfoSkeleton = () => (
  <Layout
    avatarSlot={<Skeleton className="size-[80px] rounded-full" />}
    displayNameSlot={
      <TextSkeleton className="w-[100px]" fontSize={16} lineHeight={20} />
    }
    factionSlot={
      <TextSkeleton className="w-[60px]" fontSize={12} lineHeight={15} />
    }
  />
);
